module.exports = __webpack_public_path__ + "img/atk.8c25f26d.png";